import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Box, ThemeProvider } from '@mui/material';
import Search from './Search';
import Lists from './Lists';
import { QueryClientProvider, QueryClient } from 'react-query';
import ListDetails from './ListDetails';
import Navigation from './Navigation';
import Swipe from './Swipe';
import theme from './theme';

function App() {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <Router>
          <Box>
            <Navigation></Navigation>

            {/* Main Content */}
            <Box component="main" sx={{ flexGrow: 1, padding: 3 }}>
              <Routes>
                <Route path="/lists/search" element={<Search/>} />
                <Route path="/lists/:productListId/swipe" element={<Swipe/>} />
                <Route path="/lists" element={<Lists/>} />
                <Route path="/lists/:id" element={<ListDetails />} />
              </Routes>
            </Box>
          </Box>
        </Router>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
